import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import {
  verifyAccounts,
  RoleUpdate,
  NewRole,
  verifyAccountsV2,
} from "../models/request/shareReq";
import { verifyAccountResponse } from "../models/response/shareRes";
import { Config } from "../../core/config";
import { PaymentPageReq } from "../../pages/receive/model/makePaymentReq";
import { TokenService } from "../../core/tokenManagement/token.service";
declare var $: any;
import { map } from "rxjs/operators";
import { DataStore } from "../data-store.service";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { DashboardResponse } from "../../pages/dashboard/dashaboard/model";

@Injectable()
export class SharedService {
  constructor(
    private http: HttpClient,
    private resource: Config,
    private tokenservice: TokenService,
    private dataservice: DataStore
  ) {
    // this.dataservice.currentBaseUrl$.subscribe((data) => {
    //   console.log(data);
    //   this.baseUrl = data;
    // });
  }
  // baseUrl: string;
  ngUrl: string = environment.url;
  baseUrl: string = environment.ghBaseUrl;
  helperUrl: string = this.resource.accessControlUrl;

  getBanks() {
    return this.http.get("/assets/resource/banks.json");
  }

  getIndustries() {
    return this.http.get("/assets/resource/industries.json");
  }

  getPaymentPages(id) {
    let queryParams = new HttpParams();
    queryParams = queryParams.set("startDate", "2025-04-30");
    return this.http.get(
      `${this.baseUrl}${this.resource.paymentPages}${id}/paymentPages`,
      { params: queryParams }
    );
  }

  //https://services.globalaccelerex.com
  getDashBoardData(minTransactionDate: string): Observable<DashboardResponse> {
    let userLocalDetails = this.tokenservice.getUserCred();
    let country = userLocalDetails["country"];
    let url =
      country == "GHA" ? this.baseUrl : "https://services.globalaccelerex.com";
    let params = new HttpParams();

    let maxTransactionDate = new Date().toISOString().substring(0, 10);
    params = params.append("endDate", maxTransactionDate);
    params = params.append("paymentChannel", "true");
    params = params.append("settlement", "true");
    params = params.append("startDate", minTransactionDate);
    return this.http.get<DashboardResponse>(
      `${url}${this.resource.analytics}/${userLocalDetails["clientId"]}`,
      {
        params,
      }
    );
  }

  //deprecated account lookup endpoint //new endpoint below(accountVerificationv2)
  accountVerification(accountDetails: verifyAccounts) {
    return this.http.post<verifyAccountResponse>(
      `${this.helperUrl}${this.resource.accountLookup}`,
      JSON.stringify(accountDetails)
    );
  }
  accountVerificationv2(accountDetails: verifyAccountsV2) {
    let queryParam = new HttpParams();
    // let headers = new HttpHeaders;
    // headers = headers.set('Authorization','Basic '+ btoa(''+":"+''),)
    queryParam = queryParam
      .set("accountNumber", accountDetails.accountNumber)
      .set("accountCode", accountDetails.sortCode);
    // .set('firstName',accountDetails.firstName)
    // .set('lastName',accountDetails.lastName)
    // .set('dateOfBirth',accountDetails.dateOfBirth)
    // .set('phoneNumber',accountDetails.phoneNumber)
    // .set('userIdentifier',accountDetails.userIdentifier)
    return this.http.get<verifyAccountResponse>(
      `${this.helperUrl}${this.resource.verifyAccount}`,
      { params: queryParam }
    );
  }

  getRoles() {
    return this.http.get(`${this.baseUrl}${this.resource.getRoles}`);
  }

  getPermisssions() {
    return this.http.get(`${this.baseUrl}${this.resource.getPermissions}`);
  }

  setRole(role: RoleUpdate) {
    return this.http.post(
      `${this.baseUrl}${this.resource.setRole}`,
      JSON.stringify(role)
    );
  }

  newRole(role: NewRole) {
    return this.http.post(
      `${this.baseUrl}${this.resource.setRole}`,
      JSON.stringify(role)
    );
  }

  newAdminRole(role: NewRole) {
    return this.http.post(
      `${this.baseUrl}${this.resource.setAdminRole}`,
      JSON.stringify(role)
    );
  }

  getSingleUser(clientID: string, username: string) {
    return this.http.get(
      `${this.baseUrl}${this.resource.getClients}${clientID}/user?username=${username}`
    );
  }

  paymentPage(payreq: PaymentPageReq) {
    return this.http.post(
      `${this.baseUrl}${this.resource.paymentPage}`,
      JSON.stringify(payreq)
    );
  }

  checkPaymentStatus(clientId, ref) {
    return this.http.get(
      `${this.baseUrl}${this.resource.getPaymentDetails}${clientId}/${ref}`
    );
  }

  verifyID(
    type: string,
    userIdentifier: string,
    countryCode: string,
    clientId: string
  ) {
    let queryParam = new HttpParams();
    queryParam = queryParam
      .set("type", type)
      .set("userIdentifier", userIdentifier)
      .set("countryCode", countryCode)
      .set("clientId", clientId);
    return this.http
      .get(
        `https://verification.globalaccelerex.com.gh${this.resource.verifyId}`,
        { params: queryParam }
      )
      .pipe(
        map((res) => {
          return res["data"];
        })
      );
  }

  getLocation(): any {
    return this.http.get("https://extreme-ip-lookup.com/json/");
    // $.ajax()
    // .then(
    //     function success(response) {
    //        return response.country;
    //     },
    //     function fail(data, status) {
    //         return 'Nigeria'
    //     }
    // );
  }

  getSecretKey(clientId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}${this.resource.getSecretKey.replace(
        "USERNAME",
        clientId
      )}`
    );
  }

  updateUserKey(clientId: string) {
    return this.http.post<any>(
      `${this.baseUrl}${this.resource.updateSecretKey.replace(
        "USERNAME",
        clientId
      )}`,
      {}
    );
  }

  permissions = {
    CREATE_DISBURSEMENT: false,
    PROCESS_DISBURSEMENT: false,
    GET_DISBURSEMENT: false,
    REDO_DISBURSEMENT: false,
    UPLOAD_DISBURSEMENT: false,
    ROLE_MANAGEMENT: false,
    UPDATE_PASSWORD: false,
    CREATE_CLIENT_USERS_CUSTOMER: false,
    EDIT_CLIENT_USERS_CUSTOMER: false,
    DELETE_CLIENT_USERS_CUSTOMER: false,
    GET_CLIENT_USERS_CUSTOMER: false,
    MANAGE_CLIENT_USERS_CUSTOMER_GROUPS: false,
    DELETE_CLIENT_USERS_CUSTOMER_GROUPS: false,
    GET_CLIENT_USERS_CUSTOMER_GROUPS: false,
    CREATE_CLIENT_USERS: false,
    GET_CLIENT_BALANCE: false,
    GET_CLIENT_INFO: false,
    GET_CLIENT_USER_INFO: false,
    GET_CLIENT_TRANSACTION: false,
    GET_CLIENT_TRANSACTION_SELF: false,
    UPDATE_CLIENT_USERS: false,
    GET_CLIENT_ACCOUNTS: false,
    UPDATE_CLIENT_STATUS: false,
    MANAGE_PAYMENT_PAGES: false,
    GET_CLIENT_SETTLEMENTS: false,
    UPDATE_CLIENT_ACCOUNTS: false,
    CLIENT_MANAGEMENT: false,
  };

  allPerms = [
    { name: "CREATE_DISBURSEMENT", value: false },
    { name: "PROCESS_DISBURSEMENT", value: false },
    { name: "GET_DISBURSEMENT", value: false },
    { name: "REDO_DISBURSEMENT", value: false },
    { name: "UPLOAD_DISBURSEMENT", value: false },
    { name: "ROLE_MANAGEMENT", value: false },
    { name: "UPDATE_PASSWORD", value: false },
    { name: "CREATE_CLIENT_USERS_CUSTOMER", value: false },
    { name: "EDIT_CLIENT_USERS_CUSTOMER", value: false },
    { name: "DELETE_CLIENT_USERS_CUSTOMER", value: false },
    { name: "GET_CLIENT_USERS_CUSTOMER", value: false },
    { name: "MANAGE_CLIENT_USERS_CUSTOMER_GROUPS", value: false },
    { name: "DELETE_CLIENT_USERS_CUSTOMER_GROUPS", value: false },
    { name: "GET_CLIENT_USERS_CUSTOMER_GROUPS", value: false },
    { name: "GET_CLIENT_BALANCE", value: false },
    { name: "GET_CLIENT_INFO", value: false },
    { name: "GET_CLIENT_USER_INFO", value: false },
    { name: "GET_CLIENT_TRANSACTION", value: false },
    { name: "GET_CLIENT_TRANSACTION_SELF", value: false },
    { name: "GET_CLIENT_ACCOUNTS", value: false },
    { name: "UPDATE_CLIENT_STATUS", value: false },
    { name: "MANAGE_PAYMENT_PAGES", value: false },
    { name: "GET_CLIENT_SETTLEMENTS", value: false },
    { name: "UPDATE_CLIENT_ACCOUNTS", value: false },
    { name: "CLIENT_MANAGEMENT", value: false },
  ];

  //get user permissions.
  userPermissions;
  getUserPersonalDetails() {
    let profile = this.tokenservice.getPersonalDetails();
    this.userPermissions = profile["permissions"];
    return true;
  }
  async activatePermmisions() {
    if (this.getUserPersonalDetails()) {
      let a = 0;
      let b = 0;
      let serverPermsKeys = Object.keys(this.permissions);
      for (a = 0; a < this.userPermissions.length; a++) {
        for (b = 0; b < serverPermsKeys.length; b++) {
          if (this.userPermissions[a] == serverPermsKeys[b]) {
            this.permissions[serverPermsKeys[b]] = true;
          }
        }
      }
    }
  }
}
